import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Reports(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_REPORTS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.GET_REPORTS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.GET_REPORTS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}